export enum Leaver {
    OwnerLandlord = 'owner-landlord-leaver', // eigenaar ( verhuurder )
    OwnerLeaver = 'owner-leaver', // eigenaar ( verkoper )
    TenantLeaver = 'tenant-leaver', // vorige huurder
    LandAgent = 'land-agent', // rentmeester
}
